import type { CompareV2SettingsType } from "../reducers/CompareV2SettingsReducer";

export const COMPARE_V2_SETTINGS_INIT = "compareV2Settings/init";

type InitCompareV2SettingsType = {
    type: typeof COMPARE_V2_SETTINGS_INIT;
    initState: CompareV2SettingsType;
};

export const initCompareV2Settings = (initState: CompareV2SettingsType): InitCompareV2SettingsType => ({
    type: COMPARE_V2_SETTINGS_INIT,
    initState,
});

export type CompareV2SettingsActionsType = InitCompareV2SettingsType;
